export default __webpack_public_path__ + "static/media/justech.2750acb7.png";